/**
 * A module to handle making HTTP requests.
 */
class Request {

  /**
   * Method to make an HTTP GET request.
   * @param {String} url  The URL to request.
   * @param {Object} options  The options to provide.
   */
  async get(url, options = {}) {

    options.method = "GET";

    return await this.fetch(url, options);

  }

  /**
   * Method to make an HTTP POST request.
   * @param {String} url  The URL to request.
   * @param {Object} data  The data to send in the request body.
   * @param {Object} options  The options to provide.
   */
  async post(url, data = {}, options = {}) {

    options.data = data;

    return await this.fetch(url, options);

  }

  /**
   * Method to make an HTTP PUT request.
   * @param {String} url  The URL to request.
   * @param {Object} data  The data to send in the request body.
   * @param {Object} options  The options to provide.
   */
  async put(url, data = {}, options = {}) {

    options.method = "PUT";
    options.data = data;

    return await this.fetch(url, options);

  }

  /**
   * Method to make an HTTP DELETE request.
   * @param {String} url  The URL to request.
   * @param {Object} options  The options to provide.
   */
  async delete(url, options = {}) {

    options.method = "DELETE";

    return await this.fetch(url, options);

  }

  /**
   * Method to make an HTTP request via fetch.
   * @param {String} url  The URL to request.
   * @param {Object} options  The options to provide.
   */
  async fetch(url, options = {}) {

    const headers = options.headers || [];
    const auth = options.auth;
    const json = options.json !== false;
    const data = options.data ? options.data : null;
    const body = json && data ? JSON.stringify(data) : data;

    // Add the JSON content type unless explicity set to false
    if (json) {
      headers.push(["Content-Type", "application/json"]);
    }

    // Add the auth token unless explicity set to false
    if (auth !== false) {
      // Default to the value in the options
      let token = options.token || auth;
      // If a token value is found, add the authorization header
      if (token) {
        headers.push(["Authorization", `Bearer ${token}`]);
      }
    }

    // Make the fetch request with the provided values or defaults
    const response = await window.fetch(url, {
      method: options.method || "POST",
      mode: options.mode || "cors",
      body,
      headers,
    });

    // Return the promise for the JSON data result or the default response
    return json ? response.json() : response;

  }

}

// Export the class as a singleton / static class by creating an instance
export default new Request();
